module.exports = __webpack_public_path__ + "img/shopping-cart.7beac918.svg";